import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { purpurColorGray50 } from '@purpurds/tokens/color/variables';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const SectionItem = styled.div `
  display: flex;
  justify-content: space-between;
  padding: ${spacing.spacing4} ${spacing.spacing16};
  letter-spacing: normal;

  :nth-child(even) {
    background-color: ${purpurColorGray50};
  }
`;
const SectionItemHeader = styled.div ``;
const StyledSpan = styled.span `
  color: ${({ $statusColor }) => $statusColor};
`;
export const Item = ({ header, value = 0, statusColor, secondValue, secondColor, unit, }) => (_jsxs(SectionItem, { children: [_jsx(SectionItemHeader, { children: header }), _jsxs("div", { children: [_jsx(StyledSpan, { "$statusColor": statusColor, children: ` ${value} ` }), secondValue && (_jsxs("span", { children: ["/", _jsx(StyledSpan, { "$statusColor": secondColor, children: ` ${secondValue} ` })] })), unit] })] }));
